








import { Component, Vue } from "vue-property-decorator";
import SubmitResetButtonGroop from "../buttons/submit-reset-button-groop.vue";
import StandartModal from "@/components/app/standart-modal.vue";

@Component({ components: { StandartModal, submit: SubmitResetButtonGroop } })
export default class AdminPassword extends Vue {
  password = "";

  onSubmit(event: HTMLFormElement): void {
    event.preventDefault();
    this.$store.dispatch("setAdmin", true);
    this.$nextTick(() => this.$bvModal.hide("admin-password"));
  }
}
